import { createFileRoute } from "@tanstack/react-router";

import { ProductPrioritiesDashboard } from "../tools/dashboards/ProductPrioritiesDashboard";

function ProductPrioritiesRoute() {
  return <ProductPrioritiesDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/product-priorities")({
  component: ProductPrioritiesRoute,
});
